import BulkErrorsDisplay from './BulkErrorsDisplay';

export default BulkErrorsDisplay;
